import ResizeObserver from 'resize-observer-polyfill'
import { positionReviews } from "javascripts/landingpages/review_positioner";
import { PhoneVerifier } from 'javascripts/phone_verifier.js'
import { captureSplitTestGoal2 } from 'javascripts/split_test_campaigns.js'

if ($('#phone-verification-modal').length) {
  import('javascripts/modal_verify_phone');
}

const ro = new ResizeObserver(() => positionReviews('.consent-form-container'));

if($('.lead-form').length > 1) {
  // if multiple lead forms exist on the page, give the ids each a unique ID
  $('.lead-form').each(function(index) {
    $(this).attr('id', `leadform_${index}`);
    let dataValidator = `data-parsley-validate-phone-number${index}`;
    $(this).find('.phone-error').addClass(`phone-error${index}`)
    $(this).find('.user-phone').attr('id', `user_phone_${index}`).attr(dataValidator, '').attr('data-parsley-errors-container', `.phone-error${index}`);
    $(this).find('.checkbox-error').attr('id', `checkbox_error_${index}`).prev().find('input').attr('data-parsley-errors-container', `#checkbox_error_${index}`);
    $(this).find("[name='form_id']").val(`#leadform_${index}`);
  })
}

$('.lead-submit').on('click', function() {
  let activeLeadForm = $(this).parents('form');
  let userPhone = activeLeadForm.find('.user-phone');
  $.phoneVerification.userVerificationPhone.val(userPhone.val());
  let phoneVerifier = new PhoneVerifier({ leadFormSelector: activeLeadForm }); //reset
  $.phoneVerification.phoneVerifier = phoneVerifier // reset

  let formId = '#' + $(this).parents('form').attr('id');
  if($(formId).parsley().isValid() == null) {
    // null value returned from successful custom validation, otherwise false
    // Parsley events form:success, form:submit not firing until after remote request completes. whenValid().then() also not working properly
    $(this).val('Submitting...').prop('disabled', true);
    $(formId).submit(); // lead submission stopped from the above
  }
});

$('.lead-form').on('ajax:error', function (e, data) {
  if(data.responseJSON?.errors?.base) {
    const msg = data.responseJSON.errors.base[0]
    $("#submission-error").html(msg);
  } else {
    console.error("Unexpected error while submittion user form.");
  }
});

$('.lead-form').on('ajax:success', function (e, data) {
  const { success, next_step, form_action_path, redirect_path, user_id, form_id, errors } = data;
  const twilio_response = data.twilio_response || {}

  if (!success && !errors) {
    alert('An unknown error occurred!');
    return;
  }
  captureSplitTestGoal2(data.user?.email);

  $("#submission-error").html("");

  switch (next_step) {
    case 'verify_phone':
      $(form_id).attr('action', form_action_path).attr('method', 'post');

      if (twilio_response.skip_verification) {
        $.phoneVerification.phoneVerifier.proceedSubmission(false);
        return;
      }

      if (!(initPhoneVerificationFlow(user_id, twilio_response.success))) {
        $.phoneVerification.phoneVerifier.proceedSubmission(false);
      }
      break;
    case 'user_details':
      $(form_id).attr('action', form_action_path).attr('method', 'post'); // set the next url for the form

      initUserDetailsModal(user_id, () => { $(form_id).submit() });
      break;
    case 'obtain_consent':
      maybeClosePhoneVerificationModal();

      $('.consent-form-container').find('form').attr('action', form_action_path).attr('method', 'post');
      $('.lead-form-container,.consent-form-container').toggleClass('hide-section d-none');
      setTimeout(() => positionReviews('.consent-form-container')); // using setTimeout to ensure consent form is already visible
      break;
    case 'report_was_sent_notification':

      $('a.continue-to-site-trigger').hide(); // hide Continue to PeerSpot's community button on confirmation modal
      // we want to redirect user instead of submitting the form again
      $.phoneVerification.phoneVerifier.hijackSubmissionCntrlFunc = (originalSubmission) => {
        let newPath = window.location.origin + redirect_path
        window.location.replace(newPath);
      }
      // since confirmation modal can be closed only by clicking on X in the right top corner (modal close event)
      // and we have logic that clears hijack function on modal close, we want to skip it in this case for redirect to happen
      $.phoneVerification.phoneVerifier.clearHijackFunc = false;
      
      $.phoneVerification.phoneVerifier.showConfirmationPanel();
      if (!$.phoneVerification.phoneConfirmationDialog.hasAttribute('open')) {
        $.phoneVerification.phoneConfirmationDialog.showModal();
      }
      break;
    case 'smarter_questions':
    case 'redirect':
      let button = $(form_id).find('[type="submit"]')[0]
      setTimeout(() => $(button).attr('disabled', 'disabled').text($(button).data('disable-with')));

      let newPath = window.location.origin + redirect_path
      window.location.replace(newPath);
      break;
    case 'validation_error':
      handleValidationError(form_id, errors.email);
      break;
    default:
      console.error(`Unknown step: ${next_step}`);
  }
});

function initPhoneVerificationFlow(userId, phoneIsValid) {
  try {
    const { phoneVerifier, phoneConfirmationDialog, userVerificationPhone, verificationIti } = $.phoneVerification;

    $('.phone-legend-span').text(userVerificationPhone.val());

    phoneVerifier.userId = userId;

    if (!phoneIsValid) { phoneVerifier.$phoneInput.val('') } // if phone number is invalid - we clear the input

    verificationIti.setNumber(userVerificationPhone.val()); // init intlTelInput with user's phone number, phone was already set

    phoneVerifier.showEditPhonePanel();
    phoneConfirmationDialog.showModal();
    setTimeout(_ => phoneConfirmationDialog.classList.add('open-dialog'));

    return true;
  } catch (error) {
    console.error(error);
    return false; // proceed with submission if any error occurs during verification modal setup
  }
}

function maybeClosePhoneVerificationModal() {
  if (!$.phoneVerification) { return }

  const { phoneConfirmationDialog } = $.phoneVerification;

  if (phoneConfirmationDialog) { phoneConfirmationDialog.close() }
}

$('.consent-form-container [type="checkbox"]').change(function () {
  if ($('.consent-form-container [type="checkbox"]').is(':checked')) {
    $('.custom-form-content').siblings('.field-button').removeClass('no-checks')
  } else {
    $('.custom-form-content').siblings('.field-button').addClass('no-checks')
  }
});

function handleValidationError(formId, errorMessage) {
  const form = $(formId);
  const emailField = form.find('#user_email');
  
  if (emailField.length) {
    const parsleyInstance = emailField.parsley();
    parsleyInstance.addError('serverError', {
      message: errorMessage,
      updateClass: true
    });
    emailField.focus();
  } else {
    console.error('Email field not found in the form.');
  }
}

function initUserDetailsModal(userId, proceedSubmissionFunc) {
  try {

    $('body').on('click', '.continue-to-site-trigger', function (e) {
      e.preventDefault();
      proceedSubmissionFunc();
    })

    $.ajax({
      url: `/users/${userId}/user_details_modal_content`,
      type: 'GET',
      dataType: 'json',
      success: (response) => {
        $.phoneVerification.phoneVerifier.drawCustomPanel(response.content);
        $.phoneVerification.phoneVerifier.showCustomPanel();
        setTimeout(_ => {
          if (!$.phoneVerification.phoneConfirmationDialog.hasAttribute('open')) {
            $.phoneVerification.phoneConfirmationDialog.showModal();
          }
        }, 500);

        $('#user-details-form').on('ajax:success ajax:error', function(e, data) {
          $.phoneVerification.phoneVerifier.showConfirmationPanel();
        });
      },
      error: (response) => {
        console.error(response);
        $.phoneVerification.phoneVerifier.showConfirmationPanel();
      }
    })
  } catch (error) {
    console.error(error);
    proceedSubmissionFunc();
  }
}
